<main class="component">
  <h2>404</h2>
  <p>Resourcen blev ikke fundet.</p>
  <div class="link-container">
    <a routerLink="/"><i class="fas fa-arrow-left"></i> Til forsiden</a>
  </div>
</main>